module.exports = __webpack_public_path__ + "static/media/splash.4c4d5ed0.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/splash.png
// module id = 364
// module chunks = 0